import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=81c74b0c&scoped=true"
import script from "./PageHeading.vue?vue&type=script&lang=js"
export * from "./PageHeading.vue?vue&type=script&lang=js"
import style0 from "./PageHeading.vue?vue&type=style&index=0&id=81c74b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c74b0c",
  null
  
)

export default component.exports